export default {"src":"/_next/static/media/map.cd2c2397.svg","height":171,"width":356,"blurWidth":0,"blurHeight":0};